module.exports = __webpack_public_path__ + "static/media/buy_question_3.ed91ee4f.jpg";